import React from 'react'
import Popup from '../../../../../../components/popup/Popup'
import Loadable from '../../../../../../components/loadable/Loadable'
import Label from '../../../../../../components/label/Label'
import Button from '../../../../../../components/button/Button'
import { BUTTON_TYPE } from '../../../../../../components/button/constants'
import styles from "./EDeliveryRequestInfoModal.styles"

const EDeliveryRequestInfoModal = ({ isOpen = false, onCancelCb = () => { }, onSubmitCb = () => { }, requestedForms = {}, selectedForms = [] }) => {
    return (
        <Popup
            isPopupOpen={isOpen}
            showClose={false}
            customPopupSyles={styles.customPopupSyles}
        >
            <div style={styles.bodyContent}>
                <div>
                    <div>
                        <Label>No. of Total Forms requested: {selectedForms?.length || 0}</Label>
                    </div>

                    <div>
                        <Label>No. of forms already requested: {requestedForms?.alreadyRequestedForms?.length || 0}</Label>
                    </div>

                    <div>
                        <Label>No. of New eDelivery Requested: {requestedForms?.newlyRequestedForms?.length || 0}</Label>
                    </div>
                </div>

                <div>
                    <b>Note: Recipient consent which are declined will not consider for eDelivery.</b>
                </div>

                <div>Please click on <b>Proceed to complete the process, otherwise click on Cancel to return to the previous page.</b></div>

                <div style={styles.buttonsContainer}>
                    <Button onClickCb={onSubmitCb}>Proceed</Button>
                    <Button onClickCb={onCancelCb} style={{}} type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}>Cancel</Button>
                </div>
            </div>
        </Popup>
    )
}

export default EDeliveryRequestInfoModal